export function RequiredIndicator() {
  return (
    <span className="text-fg-danger ml-0.5" aria-hidden="true">
      *
    </span>
  );
}
